import { inject }                                                     from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Store }                                                      from '@ngrx/store';
import { initCaisse }                                                 from 'src/app/shared/ngrx/store/actions/config.actions';
import { IAppState }                                                  from 'src/app/shared/ngrx/store/state/app.state';
import { LocalStorageUtil }                                           from 'src/app/shared/utils/localStorageUtil';


export const SelfCareGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const _store = inject (Store<IAppState>);
  LocalStorageUtil.reinitProfile ();
  _store.dispatch (initCaisse ());
  return true;
};

